<nb-card>
  <nb-card-body>
    <div class="table-responsive">
      <ng2-smart-table
        [settings]="settings"
        [source]="source"
        (userRowSelect)="selectedItem($event)"
      >
      </ng2-smart-table>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <h6 class="text-hint">
      Tổng cộng :
      <strong class="text-danger">{{ workingTasks.length | number }}</strong>
      việc
    </h6>

    <nb-select
      outline
      shape="round"
      size="small"
      status="info"
      [(ngModel)]="perPage"
      (selectedChange)="changePerPage()"
    >
      <nb-option value="10" selected>10</nb-option>
      <nb-option value="50">20</nb-option>
      <nb-option value="100">100 </nb-option>
      <nb-option value="1000">1000</nb-option>
    </nb-select>
  </nb-card-footer>
</nb-card>
